import { Reveal } from "./Motion";
import { CTAPair } from "./CTA";

const PageHero = ({ kicker, title, lede, service, testidPrefix = "page" }) => (
  <section data-testid={`${testidPrefix}-hero`} className="bg-paper relative grain">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 pt-14 pb-12 md:pt-20 md:pb-16">
      <Reveal>
        {kicker && (
          <p className="font-mono text-xs uppercase tracking-[0.22em] text-steel font-semibold mb-4" data-testid={`${testidPrefix}-kicker`}>{kicker}</p>
        )}
        <h1 className="font-display font-black tracking-tight leading-[1.05] text-4xl sm:text-5xl lg:text-6xl max-w-4xl" data-testid={`${testidPrefix}-title`}>
          {title}
        </h1>
        {lede && <p className="mt-6 max-w-2xl text-lg text-smoke leading-relaxed" data-testid={`${testidPrefix}-lede`}>{lede}</p>}
        <div className="mt-8">
          <CTAPair service={service} testidPrefix={`${testidPrefix}-cta`} />
        </div>
      </Reveal>
    </div>
  </section>
);

export default PageHero;
